import type { Identity } from '../api/client';
import type { RuntimeConfig } from '../auth/oauth';
import { signOutLocally } from '../auth/session';
import { navigate } from '../router';

export function SessionBar({
  identity,
  config,
  onSignedOut,
}: {
  identity: Identity;
  config: RuntimeConfig;
  onSignedOut: () => void;
}) {
  return (
    <header className="sessionbar">
      <a
        className="brand"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          navigate('/');
        }}
      >
        Identity broker admin
      </a>
      <div className="session">
        <span className="muted">{identity.email}</span>
        <button
          type="button"
          onClick={() => {
            void signOutLocally(config).then(() => {
              onSignedOut();
              navigate('/signed-out');
            });
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
